/*
 * OVERSIGTSKALENDER
 * 
 * Container placeres i html: <div class="overviewWrapper"><input type="date" id="startdate" name="startdate" value="@Model.StartDate" /></div>
 * Initieres med: $(".overviewWrapper").Oversigtskalender(<injicer evt. IOversigtskalenderParameters>);
 * 
 * Oversigten opdateres ved at ændre værdien i inputfeltet "startdate".
 * Husk, hvis værdien ændres via js, så afslut med at kalde .change() på feltet.
 */


// jQuery wrapper
($ => {
    $.fn.Oversigtskalender = function (parameters: Bookhus.Widgets.IOversigtskalenderParameters) {
        return this.each(function () {
            var oversigtskalender = Bookhus.Widgets.Oversigtskalender.init($(this), parameters);
        });
    };
})(jQuery);


module Bookhus.Utilities {
    interface ILiteEvent<T> {
        on(handler: { (data?: T): void }): void;
        off(handler: { (data?: T): void }): void;
    }

    export class LiteEvent<T> implements ILiteEvent<T> {
        private handlers: { (data?: T): void; }[] = [];

        public on(handler: { (data?: T): void }): void {
            this.handlers.push(handler);
        }

        public off(handler: { (data?: T): void }): void {
            this.handlers = this.handlers.filter(h => h !== handler);
        }

        public trigger(data?: T) {
            this.handlers.slice(0).forEach(h => h(data));
        }

        public expose(): ILiteEvent<T> {
            return this;
        }
    }
}


module Bookhus.Widgets {

    var localizedStrings = {
        book: {
            "da": "Book",
            "en-GB": "Book",
            "de": "Buch",
            "sv": " Bok",
            "no": "Bok"
        },
        info: {
            "da": "Info",
            "en-GB": "Info",
            "de": "Info",
            "sv": " Info",
            "no": "Info"
        }
    }

    export interface IOversigtskalenderParameters {
        culture: string;
        userId: number;
        isUserAdmin: boolean;
        associatedHouseIds: number[];
        minBookingBorder: number;
        mediumBookingBorder: number;        
        showLockInfo: boolean;
        spejder: boolean;
        mayHandleBooking: boolean;
        userIsAllowedToSeePeriodSeperations: boolean;
        separateTime: number;
        hasEventModule: boolean;
        showDaysBeforeTodayAsBooked: boolean;
        showDaysAfterTodayAsBooked: number;
        calendarStatusDisplayMode: CalendarStatusDisplayMode,
        enableStickyHeader: boolean;
        bookText: string;
        infoText: string;
        allowCalenderinfoForUsers: boolean;
    }
    export interface IHouseInfo {
        id: number;
        name: string;
        domain: string;
        companyName: string;
        encryptedData: string;
        dayStatusService: CalendarDaydataService; // Indeholder bookinger for huset i den valgte periode og getStatusForDay(dayToTest: Date)
        eventcalendarDescriptions: EventcalendarDescriptions;
    }

    interface IColorDefinition {
        name: string;
        color: string;
    }

    export class Oversigtskalender {

        private container: JQuery;
        private props: IOversigtskalenderParameters;

        private listView: JQuery;
        private bookingPopup: Bookingpopup;
        private startDate: Date;
        private commonOpeningDate: Date;
        private commonClosingDate: Date;
        private reservationRestrictions = true;
        private houses: IHouseInfo[] = [];
        private localization: Bookhus.Localization.Calendar;
        
        private updateTimeout: any;
        private separateTime: number;
        private specificHouse: string;

        private _onStartDateChange: Bookhus.Utilities.LiteEvent<Date> = new Bookhus.Utilities.LiteEvent<Date>();
        private _dateRange = 31;

        private readonly _eventContainerId: string = "eventcalendardescriptions";

        public static init(target: any, props: IOversigtskalenderParameters): Oversigtskalender {
            var extendedProps = $.extend({
                currentCulture: "da",
                currentUserId: 0,
                currentUserIsAdmin: false,
                minBookingBorder: 5,
                mediumBookingBorder: 10,
                isAdmin: false,
                associatedHouseIds: [],
                showLockInfo: false,
                spejder: false,
                mayHandleBooking: false,
                userIsAllowedToSeePeriodSeperations: false,
                separateTime: 12,
                hasEventModule: false,
                showDaysBeforeTodayAsBooked: true,
                showDaysAfterTodayAsBooked: 0,
                calendarStatusDisplayMode: CalendarStatusDisplayMode.Default,
                enableStickyHeader: false,
                bookText: '',
                infoText: '',
                allowCalenderinfoForUsers: false,
            }, props);

            const INSTANCE_NAME = 'calendar_instance';
            var $target = typeof (target) == 'string' ? $(target) : target as JQuery;            
            if (!$target.data(INSTANCE_NAME)) {
                $target.data(INSTANCE_NAME, new Oversigtskalender($target, extendedProps));
            }
            return $target.data(INSTANCE_NAME);
        }

        private constructor(container: JQuery, props: IOversigtskalenderParameters) {
            this.container = container;
            this.container.addClass('bc-wrapper');
            this.props = props;

            this.localization = new Bookhus.Localization.Calendar();
            this.bookingPopup = new Bookingpopup(this.props.culture, true, this.props.spejder, this.props.hasEventModule);
            this.getStartDate();

            this.specificHouse = container.attr('data-specificHouse');
            container.attr('data-initialized', "true");

            this._onStartDateChange.on(() => {

                this.getStartDate();

                clearTimeout(this.updateTimeout);
                this.updateTimeout = setTimeout(() => {
                    this.houses.forEach(house => {
                        this.updateHouse(house);
                    });
                }, 200);
            });

            $.getJSON(`/api/overview/GetBookingPeriodInformation?userId=${this.props.userId}`, info => {
                this.commonOpeningDate = new Date(info.openingDate).getDateWithoutTime();
                this.commonClosingDate = new Date(info.closingDate).getDateWithoutTime();
                this.reservationRestrictions = info.reservationRestrictions;
                this.initHeader();
                this.initBody();

                this.loadHouseList();
                this.setInputChangeEvent();
            });
        }

        private initHeader(): void {

            this.container.append(`
                <div class="bc-header rounded-top z-1">
                    <div class="bc-header-top row no-gutters p-4">
                        <div class="col">
                            <button type="button" class="btn btn-outline-dark prev float-right">
                                <span class="fa fa-chevron-left"></span>
                            </button>
                        </div>
                        <div class="col col-lg-4 text-center font-weight-bold">
                            <span class="bc-header-title">${this.monthTitle()}</span>
                        </div>
                        <div class="col menu-inline justify-content-end">
                            <button type="button" class="btn btn-outline-dark next">
                                <span class="fa fa-chevron-right"></span>
                            </button>
                            <button type="button" class="btn btn-light bg-transpaprent float-right ml-2 displayColorDefinitions" title="${(window as any).Bookhus.Localization.Standard.UI.Widgets.Calendar.ColorDefinitions}">
                                <i class="fas fa-info"></i>
                            </button>
                            <div class="dropdown float-right">
                                <button type="button" class="btn btn-light bg-transparent calendardatetoggle">
                                    <i class="far fa-calendar-alt"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right px-4 py-3 calenderdateselector">
                                    <form class="form-inline flex-nowrap" id="changeSelecedDate">
                                        ${this.createMonthDropdown()} ${this.createYearDropdown()} <button type="submit" class="btn btn-primary">${this.localization.get('show', this.props.culture)}</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                   <div class="bc-header-calendar-row row no-gutters">
                        <div class="bc-header-calendar syncscroll col-12 ${this.specificHouse ? 'col-lg-12' : 'col-lg-10 offset-lg-2'}" name="sync">

                        </div>
                    </div>
                </div>
            `);

            this.container.find(".calendardatetoggle").on("click", () => {
                $(".calenderdateselector").toggle();
            });

            if (this.props.enableStickyHeader) {
                this.container.addClass('bc-wrapper');
                $('.bc-header', this.container).addClass('bc-header-sticky');
            }

            

            this.renderHeaderCalendar();

            this.container.find(".prev").on("click", () => {
                this.moveMonth(-1);
            });
            this.container.find(".next").on("click", () => {
                this.moveMonth(1);
            });

            this.container.find('.displayColorDefinitions').on('click', () => {
                $.getJSON('/api/calendar/colordefinitions', (colorDefinitions: IColorDefinition[]) => {
                    var lightColors = ['#fff', '#ffffff', 'white'];

                    var htmlContent = `
                        <div id="bookinglegend">
                            <div class="bookinglegendcontainer">
                                ${
                            colorDefinitions.map((colorDefinition) =>
                                `<div class="bookingcolor">
                                            <div class="color ${lightColors.indexOf(colorDefinition.color.toLowerCase()) > -1 ? 'isempty' : ''}" style="background-color: ${colorDefinition.color}"></div>${colorDefinition.name}
                                        </div>`).join('')
                                }
                            </div>
                        </div>
                    `;

                    swalModal.fire({
                        title: (window as any).Bookhus.Localization.Standard.UI.Widgets.Calendar.ColorDefinitions,
                        html: htmlContent
                    });
                });
            });

            this.container.find('#changeSelecedDate').on('submit', (e) => {
                e.preventDefault();
                e.stopPropagation();

                var $form = $(e.target);
                var selectedMonth = $('select[name="month"]', $form).val();
                var selectedYear = $('select[name="year"]', $form).val();
                this.moveToMonthInYear(selectedMonth, selectedYear);
                $form.closest('.dropdown').children('button[data-toggle="dropdown"]').dropdown('hide');
            });

            this._onStartDateChange.on((date) => {
                $('.bc-header .bc-header-title').text(`${this.monthTitle()}`);

                this.container.find(".monthDropdown").val(this.startDate.getMonth().toString());
                this.container.find(".yearDropdown").val(this.startDate.getFullYear().toString());

                this.renderHeaderCalendar();
            });
        }

        private monthTitle(): string {
            console.log("T", this.props.culture, this.startDate)
            var title = `${this.localization.getValues('monthNames', this.props.culture)[this.startDate.getMonth()]} ${this.startDate.getFullYear()}`;
            var enddate = this.startDate.addDays(30) as Date;
            if (enddate.getMonth() != this.startDate.getMonth()) {
                title += ` - ${this.localization.getValues('monthNames', this.props.culture)[enddate.getMonth()]} ${enddate.getFullYear()}`;
            }
            return title;
        }

        private renderHeaderCalendar(): void {
            var startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
            var endDate = new Date(startDate.getTime()).addDays(this._dateRange);
            //endDate.setMonth(this.startDate.getMonth() + 1);

            var calendarWeeks = "";
            while (startDate.getTime() < endDate.getTime()) {
                var currentWeek = startDate.getWeek();

                var datoer = "";
                do {
                    var text = "";
                    var backgroundColor = "bg-light";
                    var textColor = "text-primary";
                    if (startDate.isHolyday()) {
                        backgroundColor = "bg-holiday";
                        textColor = "text-light";
                        text = `title="${startDate.getHolydayName()}"`;
                    }

                    datoer += `
                    <div class="day col calenderdate ${backgroundColor} ${textColor}" ${text}>
                        <span>${this.localization.getValues('dayNamesMin', this.props.culture)[startDate.getDay()]}</span>
                    </div>`;

                    startDate = startDate.addDays(1);
                }
                while (startDate.getWeek() == currentWeek && startDate.getTime() < endDate.getTime())

                calendarWeeks += `
                    <div class="weekCs d-flex flex-column text-nowrap">
                        <div class="weekCount">${this.localization.get('weekHeader', this.props.culture)} ${currentWeek}</div>
                        <div class="calenderDays d-flex flex-row justify-content-center">${datoer}</div>
                    </div>
                `;
            }

            $('.bc-header .bc-header-calendar', this.container).empty().append(`<div class="monthCs">${calendarWeeks}</div>`);
        }

        private initBody(): void {
            this.container.append(`
                <div class="bc-body rounded-bottom">
                    <div class="bc-list-view">

                    </div>
                </div>
            `);

            this.listView = this.container.find('.bc-list-view');
        }

        private getStartDate() {
            var startDate = this.container.data('startdate');
            console.log(startDate, this.localization.get('dateFormat', this.props.culture))
            var parsedDate = $.datepicker.parseDate(this.localization.get('dateFormat', this.props.culture), startDate);
            if (parsedDate < new Date(2000, 1, 1)) {
                parsedDate = new Date(Date.now());
            }
            this.startDate = parsedDate;
        }

        public setStartDate(date: Date) {
            var formattedDate = $.datepicker.formatDate(this.localization.get('dateFormat', this.props.culture), date);
            this.container.data('startdate', formattedDate);
            this._onStartDateChange.trigger(date);
        }

        private setInputChangeEvent() {
            this.findInputField().on("change", (e) => {
                //Ved ikke om andre scripts sætter input value, men indtil vi har fået det undersøgt. Så lytter vi stadig på det..
                var inputValue = $(e.target).val();
                var parsedDate = $.datepicker.parseDate(this.localization.get('dateFormat', this.props.culture), inputValue);
                this.setStartDate(parsedDate);
            });
        }

        private findInputField(): JQuery {
            var inputField = this.container.find("#startdate");
            if (inputField === undefined || inputField === null) {
                throw new Error("Datofeltet findes ikke");
            }
            return inputField;
        }

        

        private createMonthDropdown(): string {
            var monthDrop = "";
            this.localization.getValues('monthNames', this.props.culture).forEach((month, index) => {
                var selected = index === this.startDate.getMonth() ? ' selected="selected"' : "";
                monthDrop += `<option value="${index}"${selected}>${month}</option>`;
            });
            return `<select class="form-control mr-2" name="month">${monthDrop}</select>`;
        }

        private createYearDropdown(): string {
            var yearDrop = "";
            var yearsBack = -5;
            var yearsForward = 5;
            for (var i = yearsBack; i <= yearsForward; i++) {
                var currentYear = this.startDate.getFullYear() + i;
                var selected = currentYear === this.startDate.getFullYear() ? ' selected="selected"' : "";
                yearDrop += `<option value="${currentYear}"${selected}>${currentYear}</option>`;
            }
            return `<select class="form-control mr-2" name="year">${yearDrop}</select>`;
        }


        private loadHouseList(): void {
            var url = `/api/overview/houselist?locale=${this.props.culture}&userId=${this.props.userId}`;
            if (this.specificHouse) {
                url += `&houseid=${this.specificHouse}`;
            }
            $.getJSON(url, houses => {
                if (houses.length > 0) {

                    var externalHouses = [];

                    houses.forEach(house => {
                        if (house.domain) {
                            externalHouses.push(house);
                            return;
                        }

                        var newHouse: IHouseInfo = {
                            id: house.id,
                            name: house.name,
                            domain: '',
                            companyName: '',
                            encryptedData: '',
                            dayStatusService: new CalendarDaydataService(this.props.minBookingBorder, this.props.mediumBookingBorder, this.props.userId, this.props.isUserAdmin || this.props.userIsAllowedToSeePeriodSeperations, this.props.separateTime, this.props.calendarStatusDisplayMode),
                            eventcalendarDescriptions: EventcalendarDescriptions ? new EventcalendarDescriptions(this.props.culture, this._eventContainerId, house.id) : null
                        }
                        this.houses.push(newHouse);
                        this.drawHouseContainer(newHouse);
                    });

                    //Vi behøver kun vise ekstern header, hvis man også har egne emner
                    if (externalHouses.length > 0 && houses.length - externalHouses.length > 0) {
                        this.drawExternalHeader();
                    }

                    externalHouses.forEach(house => {
                        var newHouse: IHouseInfo = {
                            id: house.id,
                            name: house.name,
                            domain: house.domain ? 'https://' + house.domain : '',
                            companyName: house.companyName || '',
                            encryptedData: house.encryptedData || '',
                            dayStatusService: new CalendarDaydataService(this.props.minBookingBorder, this.props.mediumBookingBorder, this.props.userId, this.props.isUserAdmin || this.props.userIsAllowedToSeePeriodSeperations, this.props.separateTime, this.props.calendarStatusDisplayMode),
                            eventcalendarDescriptions: null
                        }
                        this.houses.push(newHouse);
                        this.drawHouseContainer(newHouse);
                    });

                    // Done drawing 
                    this.scrollToExternal();
                }
            });
        }

        private scrollToExternal(): void {
            //debugger;
            var $target = $(location.hash);
            if ($target.hasClass('bc-list-header')) {
                var targetTop = $target.offset().top;
                $('html, body').animate({ scrollTop: targetTop }, 500);
            }
        }

        private drawExternalHeader(): void {
            this.listView.append(`
                <div class="bc-list-header" id="externalproperties">
                    ${this.localization.get('externalHouses', this.props.culture)}
                </div>
            `);
        }

        private drawHouseContainer(house: IHouseInfo): void {
            //var house = this.houses.find(h => h.id === id);

            var hide = "";
            var width = "col-lg-10";
            if (this.specificHouse) {
                hide = ' style="display:none;" ';
                var width = "col-lg-12";
            }

            this.listView.append(`
                <div class="bc-list-item" data-houseid="${house.id}" id="house-${house.id}">
                    <div class="row no-gutters flex-column flex-sm-row">
                        <div class="openinfo-${house.id} bc-list-item-title col-12 col-lg-2 px-4" data-toggle="collapse" data-target="[data-houseid='${house.id}'] .bc-list-item-info" role="button" aria-expanded="false" ${hide}>
                            <span>${house.name}</span>
                            <span class="fa fa-spinner fa-spin d-none"></span>
                            <span class="fa fa-chevron-down "></span>
                        </div>
                        <div class="bc-list-item-calendar syncscroll col-12 ${width}" name="sync">
                        </div>
                    </div>
                    <div class="bc-list-item-info p-2 collapse">
                    </div>
                </div>
            `);

            var content = document.querySelector(`.openinfo-${house.id}`);
            content.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.loadHouseInfo(house);
                return;
            });

            //$(`[data-houseid="${house.id}"] .bc-list-item-info`).on("show.bs.collapse", (e) => {
                
            //    if (!$(`[data-houseid="${house.id}"] .bc-list-item-info`).data('content-loaded')) {
            //        e.preventDefault();
            //        e.stopPropagation();
            //        this.loadHouseInfo(house);
            //        return;
            //    }
                
            //});
            this.updateHouse(house);
            if ((window as any).syncscroll) {
                (window as any).syncscroll.reset();
            }
        }

        private updateHouse(house: IHouseInfo): void {
            if (!this.startDateIsInOpenPeriod()) {
                return;
            }
            var $listItem = $(`[data-houseid="${house.id}"]`);
            //$('.bc-list-item-calendar', $listItem).empty();
            $('.fa-spinner:has(.d-none)', $listItem).removeClass('d-none');

            var self = this;
            //var startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), 1);
            //var endDate = new Date(startDate.getTime());
            //endDate.setMonth(this.startDate.getMonth() + 1);
            var startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
            var endDate = new Date(startDate.getTime()).addDays(this._dateRange);

            var xhr = house.dayStatusService.loadDataAjax(house.id, startDate, endDate, house.domain);
            xhr.always(function (jqxhr, textStatus, error) {
                self.drawHouseCalender(house);
            });
        }

        private drawHouseCalender(house: IHouseInfo): void {
            var self = this;
            var calendar = "";
            var today = new Date().getDateWithoutTime().addDays(self.props.showDaysAfterTodayAsBooked);

            var startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
            var endDate = new Date(startDate.getTime()).addDays(this._dateRange);

            var calendarWeeks = "";
            while (startDate.getTime() < endDate.getTime()) {
                var currentWeek = startDate.getWeek();

                var calendarDays = "";
                do {
                    var title = self.isAdmin(house) ?
                        this.localization.get('clickToSelectDate', this.props.culture) :
                        this.localization.get('clickForMoreInformation', this.props.culture);

                    var currentDayStatus = house.dayStatusService.getStatusForDay(startDate, !!house.domain);
                    var dayEventStatus = house.dayStatusService.getEventstatusForDay(startDate);
                    if (!!house.domain) {
                        currentDayStatus = currentDayStatus.replace(/drawperiod/g, 'reservation');
                    }


                    var dayHasPrice = house.dayStatusService.dayHasPrice(startDate);
                    if (!dayHasPrice) {
                        currentDayStatus = "noprice";
                    }

                    var dayActive = "";
                    var disableSysMaxForDay = house.dayStatusService.sysMaxDateGælderIkkeForLodtrækninger && currentDayStatus.indexOf('drawperiod') > -1;
                    if (this.reservationRestrictions && (!dayHasPrice || (startDate > house.dayStatusService.houseOpenUntill && !disableSysMaxForDay) || startDate > this.commonClosingDate || currentDayStatus.indexOf('restrictedPeriod') > -1)) {
                        dayActive = "day-not-active";
                        title = "";
                    }
                    currentDayStatus = currentDayStatus.replace('restrictedPeriod', '');

                    if (currentDayStatus.indexOf("locked") > -1 && !this.props.showLockInfo && !self.isAdmin(house)) {
                        currentDayStatus = currentDayStatus.replace("locked", "reservation");
                    }
                    else if (currentDayStatus.indexOf("locked") > -1 && this.props.showLockInfo && self.isAdmin(house)) {
                        title = this.localization.get('periodIsLocked', this.props.culture) + '. ' + this.localization.get('clickForMoreInformation', this.props.culture);
                    }
                    else if (currentDayStatus.indexOf("locked") > -1 && this.props.showLockInfo) {
                        title = this.localization.get('periodIsLocked', this.props.culture);
                    }

                    if (self.props.showDaysBeforeTodayAsBooked && startDate.getDateWithoutTime().getTime() < today.getTime() && !self.isAdmin(house)) {
                        currentDayStatus = "reservation";
                        title = "";
                    }

                    calendarDays += `
                    <div class="${dayEventStatus}"><div data-date="${startDate.toString("dd-MM-yyyy")}" data-title="${title}" class="day ${currentDayStatus} ${dayActive} z-0">
                        <span>${startDate.toString("dd")}</span>
                    </div></div>`;

                    startDate = startDate.addDays(1);
                }
                while (startDate.getWeek() == currentWeek && startDate.getTime() < endDate.getTime())

                calendarWeeks += `
                    <div class="weekCs d-flex flex-column text-nowrap">
                        <div class="d-flex flex-row justify-content-center">${calendarDays}</div>
                    </div>
                `;
            }

            var $listItem = $(`[data-houseid="${house.id}"]`);
            $('.bc-list-item-calendar', $listItem).empty().append(`<div class="monthCs">${calendarWeeks}</div>`);
            $('.fa-spinner:not(.d-none)', $listItem).addClass('d-none');

            $(`.day:not(".day-not-active")`, $listItem).on("click", function () {
                var dateString = $(this).attr("data-date").split("-");
                var bookingDate = new Date(+dateString[2], +dateString[1] - 1, +dateString[0]);

                var bookhusPortalPopUp = window["bookhusPortalPopUp"];
                if (bookhusPortalPopUp && house.domain.length > 0) {
                    bookhusPortalPopUp.show(house.companyName, house.encryptedData, "/book/" + house.id);
                    return;
                }
                else if (house.dayStatusService.getStatusForDay(bookingDate) === "locked" && self.props.showLockInfo) {
                    // Vis bookingpopup hvis Admin
                    if (self.isAdmin(house)) //Admin check bliver lavet her, for at undgå link til booking side på låst periode..
                    {
                        self.bookingPopup.showLockInfo(house.id, bookingDate, self.props.mayHandleBooking);
                    }
                }
                else if (self.isAdmin(house) || self.props.allowCalenderinfoForUsers) {
                    // Vis bookingpopup hvis Admin
                    self.bookingPopup.showPopup(house.id, bookingDate, self.props.mayHandleBooking).then((modelBody: JQuery) => {
                        if (house.eventcalendarDescriptions) {
                            house.eventcalendarDescriptions.loadEventDescriptionList(bookingDate, bookingDate).then((eventHtml: string) => {
                                modelBody.append(`
                                    <div class="border-top mt-3 pt-3">
                                        ${eventHtml}
                                    <div>
                                `);
                            });
                        }
                    });
                }
                else {

                    var redirectToProperty = () => {
                        var url = `/book/${house.id}?date=${$(this).attr("data-date")}`;
                        if (house.domain.length > 0) {
                            url = "https://" + house.domain + url;
                        }
                        window.location.href = url;
                    }

                    if (house.eventcalendarDescriptions) {
                        house.eventcalendarDescriptions.displayPopup(bookingDate, bookingDate).then(redirectToProperty);
                    }
                    else {
                        redirectToProperty();
                    }
                }
            });

            const TOOLTIP_DELAY: number = 500;
            const TOOLTIP_TIMEOUT: string = 'tooltipTimeout';

            $(`.day:not(".day-not-active")`, $listItem).on('mouseenter', (e) => {
                var $target = $(e.currentTarget);
                clearTimeoutData($target);
                $target.data(TOOLTIP_TIMEOUT, setTimeout(() => {
                    $target.off('mouseenter');

                    var title = $target.data('title');

                    var bookhusPortalPopUp = window["bookhusPortalPopUp"];
                    if (!this.isAdmin(house) || bookhusPortalPopUp && house.domain.length > 0) {
                        displayTooltip($target, title);
                    }
                    else {
                        var dateString = $target.attr("data-date").split("-");
                        var bookingDate = new Date(+dateString[2], +dateString[1] - 1, +dateString[0]);
                        house.dayStatusService.getTitleForDay(bookingDate).then((status) => {
                            if ($target.data(TOOLTIP_TIMEOUT)) {
                                displayTooltip($target, title + '\n ' + status);
                            }
                        });
                    }
                }, TOOLTIP_DELAY));
            });

            $(`.day:not(".day-not-active")`, $listItem).on('mouseleave', (e) => {
                var $target = $(e.currentTarget);
                clearTimeoutData($target);
            });

            function clearTimeoutData($target: JQuery) {
                clearTimeout($target.data(TOOLTIP_TIMEOUT));
                $target.data(TOOLTIP_TIMEOUT, null);
            }

            function displayTooltip($target: JQuery, title: string) {
                $target.tooltip({
                    boundary: 'window',
                    title: title,
                    trigger: 'hover',
                    delay: { show: TOOLTIP_DELAY, hide: 0 }
                } as any);

                $target.on('click', function () {
                    $(this).tooltip('hide');
                });
                $target.tooltip('show');
            }
        }

        private isAdmin(house) {
            var self = this;
            return self.props.isUserAdmin || !self.props.isUserAdmin && self.props.associatedHouseIds.indexOf(house.id) > -1;
        }

        private loadHouseInfo(house: IHouseInfo): void {
            console.log(house)
            var url = "";
            if (house.domain.length > 0) {
                url = house.domain + url;
            }

            var $listItem = $(`[data-houseid="${house.id}"]`);
            var $listItemInfo = $('.bc-list-item-info', $listItem);
            $('.fa-spinner:has(.d-none)', $listItem).removeClass('d-none');

            $listItemInfo.html("");
            if ($listItemInfo.hasClass("show")) {
                $listItemInfo.collapse('hide');
                return;
            }

            $.getJSON(`/api/overview/housedescription?locale=${this.props.culture}&houseId=${house.id}`, description => {
                var content = `
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex flex-column flex-lg-row position-relative">
                                <div class="flex-fill pr-4" style="flex-basis: 100% !important;">
                                    <img src="${url}/Houseimage/${description.imageId}/300/300" class= "img-fluid" />
                                    <div class="gallery-copyright">${description.copyright}</div>
                                </div>
                                <div class= "informationwrapper pl-lg-4">
                                    ${description.description}
                                    <p>
                                        <a href="${url}/book/${house.id}" class="btn btn-success" style="min-width: 100px;" data-bookhusportal="${(house.domain.length > 0 ? "show" : "")}" data-propertyowner="${house.companyName}" data-encrypteddata="${house.encryptedData}" data-redirectto="/book/${house.id}">${this.props.bookText || localizedStrings.book[this.props.culture]}</a>
                                        <a href="${url}/House/${house.id}" class="btn btn-info ml-2" style="min-width: 100px;" data-bookhusportal="${(house.domain.length > 0 ? "show" : "")}" data-propertyowner="${house.companyName}" data-encrypteddata="${house.encryptedData}" data-redirectto="/house/${house.id}">${this.props.infoText || localizedStrings.info[this.props.culture]}</a>
                                        <a data-toggle="modal" data-target="#priceModal" data-house-title="${house.name}" data-house-domain="${url}" data-house-id="${house.id}" href="#" class="btn btn-outline-dark ml-2" style="min-width: 100px;">${(Bookhus as any).Localization.Standard.UI.ButtonText.Prices}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                $listItemInfo.append(content).data('content-loaded', true);
                $('.fa-spinner:not(.d-none)', $listItem).addClass('d-none');
                $listItemInfo.collapse('show');
            });
        }


        public moveMonth(distance: number) {

            var oldDate = this.startDate;
            var targetDate = new Date(this.startDate.getTime());
            targetDate.setDate(1);
            targetDate.setMonth(targetDate.getMonth() + distance);

            // Vi understøtter kun 5 år frem i tiden, og lader derfor ikke brugeren futte længere frem end det..
            if (targetDate.getFullYear() > new Date(Date.now()).getFullYear() + 5) {
                return;
            }

            this.setStartDate(targetDate);
            this.getStartDate();
            if (!this.startDateIsInOpenPeriod()) {
                this.setStartDate(oldDate);
            }
        }

        public moveToMonth(target: number) {
            if (target < 0 || target > 11) {
                throw new Error("Ugyldig måned. Angiv 0 til 11.");
            }
            var targetDate = new Date(this.startDate.getTime());
            targetDate.setDate(1);
            targetDate.setMonth(target);
            this.setStartDate(targetDate);
        }

        public moveToYear(target: number) {
            var targetDate = new Date(this.startDate.getTime());
            targetDate.setDate(1);
            targetDate.setFullYear(target);
            this.setStartDate(targetDate);
        }

        public moveToMonthInYear(targetMonth: number, targetYear: number) {
            if (targetMonth < 0 || targetMonth > 11) {
                throw new Error("Ugyldig måned. Angiv 0 til 11.");
            }
            if (targetYear < 2000 || targetYear > 2100) {
                throw new Error("Ugyldigt år angivet.");
            }

            var targetDate = new Date();
            targetDate.setDate(1);
            targetDate.setMonth(targetMonth);
            targetDate.setFullYear(targetYear);

            if (!this.isDateInOpenPeriod(targetDate)) {
                return;
            }
            this.setStartDate(targetDate);
        }

        private isDateInOpenPeriod(dateToCheck: Date): boolean {
            var firstDisplayableDate = new Date(this.commonOpeningDate.getTime());
            firstDisplayableDate.setDate(1);
            return dateToCheck >= firstDisplayableDate && dateToCheck <= this.commonClosingDate;
        }

        private startDateIsInOpenPeriod(): boolean {
            var firstDisplayableDate = new Date(this.commonOpeningDate.getTime());
            firstDisplayableDate.setDate(1); // Den 1. i den måned, som har datoen for nedre grænse for booking

            return this.startDate >= firstDisplayableDate && this.startDate <= this.commonClosingDate;
        }

        private debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }

    }


}